/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.28.0
 */

import { TabMenu } from '@nexign/scc-ui-kit';
import styled from 'styled-components';

export const TabMenuInquiryTableStyled = styled(TabMenu)`
    margin-bottom: 24px;
    margin-right: auto;

    && button:first-child {
        min-width: 210px;
        padding: 0 var(--padding-m);
    }
`;

export const InquiriesTabMenuContainerStyled = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;

export const InquiriesInstructionsLinksStyled = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 24px;
    margin-left: auto;
    gap: 32px;
`
